import React from 'react';
import './HealthOneFooter.scss';
import {
  FaFacebookF, FaTwitter, FaYoutube, FaGoogle,
  FaTiktok, FaInstagram, FaLinkedinIn, FaPhoneAlt, FaArrowUp
} from 'react-icons/fa';
import { MdEmail, MdLocationOn } from 'react-icons/md';
import { FaEnvelope } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const HealthOneFooter = () => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="health-one-footer">
      <div className="health-one-footer__container">
        <div className="health-one-footer__about">
          <h2 className="health-one-footer__logo"><span>🩺</span> WeCare</h2>
          <p>
            Streamline your administrative tasks, access critical patient data, 
            and enhance collaboration among your healthcare team effortlessly.
          </p>
          <div className="health-one-footer__socials">
            <FaFacebookF /><FaTwitter /><FaYoutube /><FaGoogle />
            <FaTiktok /><FaInstagram /><FaLinkedinIn />
          </div>
        </div>

        <div className="health-one-footer__links">
          <h3>| QUICK LINKS</h3>
          <ul>
            <li onClick={() => navigate('/')}>Home</li>
            <li onClick={() => navigate('/faq')}>FAQ</li>
            <li onClick={() => navigate('/bookings')}>Bookings</li>
            <li onClick={() => navigate('/dashboard')}>Dashboard</li>
            <li onClick={() => navigate('/notifications')}>Notifications</li>
            <li onClick={() => navigate('/products-services')}>Products & Services</li>
          </ul>
        </div>

        <div className="health-one-footer__links">
          <h3>| USEFUL LINKS</h3>
          <ul>
            <li onClick={() => navigate('/aboutus')}>About Us</li>
            <li onClick={() => navigate('/disclaimer')}>Disclaimer</li>
            <li onClick={() => navigate('/contact')}>Contact Us</li>
            <li onClick={() => navigate('/return-policy')}>Return Policy</li>
            <li onClick={() => navigate('/privacy-policy')}>Privacy Policy</li>
            <li onClick={() => navigate('/support')}>Help & Support</li>
            <li onClick={() => navigate('/terms')}>Terms & Conditions</li>
          </ul>
        </div>

        <div className="health-one-footer__contact">
          <h3>| CONTACTS</h3>
          <ul>
            <li><MdLocationOn /> New Delhi, India</li>
            <li><FaEnvelope /> +91 874 900 1111</li>
            <li><FaPhoneAlt /> +91 915 255 2222</li>
          </ul>
          <div className="health-one-footer__up" onClick={scrollToTop}>
            <FaArrowUp />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default HealthOneFooter;
